import { useState } from "react";
import { createContext, useEffect } from "react";
import getArticles from "../services/getArticles";
import clienteAxios from "../config/clienteAxios";
import getBanners from "../services/getBanners";
import putBanners from "../services/putBanners";
import createBanner from "../services/createBanner";
import getBloqueInfo from "../services/getBloqueInfo";
import putBloqueInfo from "../services/putBloqueInfo";
import createBloqueInfo from "../services/createBloqueInfo";
import createArticle from "../services/createArticle";
import putArticle from "../services/putArticle";
import toast from "react-hot-toast";
import axios from "axios";

const HomeContext = createContext();

const HomeProvider = ({ children }) => {
  const [sliders, setSliders] = useState([]);
  const [categories, setCategories] = useState([]);
  const [banners, setBanners] = useState([]);
  const [bloques, setBloques] = useState([]);
  const [mensaje, setMensaje] = useState(null);
  const [bloqueInfoEdit, setBloqueInfoEdit] = useState(null);
  const [bannerEdit, setBannerEdit] = useState(null);
  const [flag, setFlag] = useState(false);

  useEffect(() => {
    getArticles().then((resp) => {
      setSliders(resp.data.allArticles);
    });
    getCategories().then((resp) => {
      setCategories(resp.data.allCategories);
    });
  }, []);

  useEffect(() => {
    getArticles().then((resp) => {
      setSliders(resp.data.allArticles);
    });
    getCategories().then((resp) => {
      setCategories(resp.data.allCategories);
    });
  }, [flag]);

  useEffect(() => {
    getBanners().then((resp) => setBanners(resp.data.allBanner));
  }, []);

  useEffect(() => {
    getBanners().then((resp) => setBanners(resp.data.allBanner));
  }, [mensaje]);

  useEffect(() => {
    getBloqueInfo().then((resp) => setBloques(resp.data.allBloqueInfo));
  }, []);

  useEffect(() => {
    getBloqueInfo().then((resp) => setBloques(resp.data.allBloqueInfo));
  }, [mensaje]);

  const getCategories = async () => {
    try {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/category/getAll`,
        responseType: "json"
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  const createCategory = async (category) => {
    const token = JSON.parse(localStorage.getItem("Usuario")).token;
    try {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/category/create`,
        data: category,
        headers: {
          authorization: token
        },
        responseType: "json"
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  const addCategory = (category) => {
    const nuevoArray = categories.some((cat) => cat.title === category.title);
    if (!nuevoArray) {
      createCategory(category).then((resp) => setMensaje("Creado"));
    }
    const newCategory = [...categories, category];
    setCategories(newCategory);
    setMensaje(null);
  };

  const handleVisibilitySlider = (id) => {
    const slidersEdit = sliders?.map((slider) =>
      slider._id === id ? { ...slider, state: !slider.state } : slider
    );
    const sliderToEdit = sliders?.find((s) => s._id === id);
    sliderToEdit.state = !sliderToEdit.state;
    //putArticle(sliderToEdit).then(({data}) => setMensaje(data.message))
    setMensaje(null);
    setSliders(slidersEdit);
  };

  const handlePublishButton = (estado, id) => {
    switch (estado) {
      case "sliders":
        const slidersEdit = sliders.map((slider) => {
          if (slider._id === id) {
            publicSliders([{ ...slider, publish: true }]);
            return { ...slider, publish: true };
          }
          return slider;
        });
        setSliders(slidersEdit);
        toast.success("Articulo Publicado");
        break;
      case "modules":
        break;
      default:
    }
  };

  const deleteArticle = (id) => {
    const sliderToDelete = sliders?.find((s) => s._id === id);
    const newSliders = sliders?.map((slider) =>
      slider._id === id
        ? {
            ...slider,
            deleted: !slider.deleted,
            deteled_by: "62cc114c55722851aaeea451",
            deleted_date: String(
              new Date().getFullYear() +
                "-" +
                String(new Date().getMonth() + 1).padStart(2, "0") +
                "-" +
                new Date().getDate()
            ).padStart(2, "0")
          }
        : slider
    );
    putArticle({
      ...sliderToDelete,
      deleted: true,
      deteled_by: "62cc114c55722851aaeea451",
      deleted_date: String(
        new Date().getFullYear() +
          "-" +
          String(new Date().getMonth() + 1).padStart(2, "0") +
          "-" +
          new Date().getDate()
      ).padStart(2, "0")
    }).then((resp) => setMensaje(resp.data.message));
    setSliders(newSliders);
    setMensaje(null);
  };

  const addSlider = (slider) => {
    createArticle(slider).then((resp) => setMensaje(resp.data.message));
    const newSliders = [...sliders, slider];
    setSliders(newSliders);
    setMensaje(null);
  };

  const editSlider = (element) => {
    putArticle(element).then((resp) => toast.success(resp.data.message));
    const slidersEdit = sliders?.map((slider) => (slider._id === element._id ? element : slider));
    setMensaje(null);
    publicSliders(slidersEdit);
    setSliders(slidersEdit);
  };

  const publicSliders = (sliders) => {
    sliders.map(async (slider) => {
      try {
        const { data } = await clienteAxios.put("/article/update", slider);
        setMensaje(data.message);
      } catch (error) {
        console.log(error);
      }
    });
  };

  const addBanner = (banner) => {
    createBanner(banner).then(({ data }) => setMensaje(data.message));
    setMensaje(null);
  };

  const deleteBanner = (id) => {
    const newBanners = banners.filter((b) => b._id !== id);
    const bannerToEdit = banners.find((b) => b._id === id);
    putBanners({
      ...bannerToEdit,
      deleted: true,
      deteled_by: "62c82774184584de326215b8"
    }).then(({ data }) => setMensaje(data.message));
    setBanners(newBanners);
  };

  const handleChecked = (id, idProduct) => {
    const bannersCheck = banners.map((b) => (b._id === id ? { ...b, state: !b.state } : b));
    const bannerToEdit = banners.find((b) => b._id === id);
    bannerToEdit.state = !bannerToEdit.state;
    putBanners(bannerToEdit).then(({ data }) => setMensaje(data.message));
    setBanners(bannersCheck);
  };

  const handleVisibilityBanners = (module, page) => {
    const updateSection = true;

    setBanners(
      banners.map((item) => {
        if (item._id === module) {
          if (item.section.find((value) => value === page)) {
            const index = item.section.indexOf(page);
            item.section.splice(index, 1);
          } else {
            item.section.push(page);
          }
        }
        return item;
      })
    );

    const bannerToEdit = banners.find((b) => b._id === module);
    bannerToEdit.state = !bannerToEdit.state;
    putBanners({ ...bannerToEdit, updateSection });
  };

  const editBanner = (values) => {
    const bannersEdit = banners.map((b) => (b._id === values._id ? { ...values } : b));
    putBanners({ ...values, updated_date: new Date() }).then(({ data }) =>
      toast.success(data.message)
    );
    setBanners(bannersEdit);
  };

  // Bloque Info
  const addBloqueInfo = (bloque) => {
    createBloqueInfo(bloque).then(({ data }) => setMensaje(data.message));
    setMensaje(null);
  };

  const deleteBloqueInfo = (id) => {
    const newBloquesInfos = bloques.filter((b) => b._id !== id);
    const bloqueToEdit = bloques.find((b) => b._id === id);
    putBloqueInfo({
      ...bloqueToEdit,
      deleted: true,
      deteled_by: "62c82774184584de326215b8"
    }).then(({ data }) => setMensaje(data.message));
    setBloques(newBloquesInfos);
  };

  const handleCheckedBloque = (id, idProduct) => {
    const bloquesCheck = bloques.map((b) => (b._id === id ? { ...b, state: !b.state } : b));
    const bloqueToEdit = bloques.find((b) => b._id === id);
    bloqueToEdit.state = !bloqueToEdit.state;
    putBloqueInfo(bloqueToEdit).then(({ data }) => setMensaje(data.message));
    setBloques(bloquesCheck);
  };

  const handleVisibilityBloque = (module, page) => {
    const updateSection = true;
    setBloques(
      bloques.map((item) => {
        if (item._id === module) {
          if (item.visible.find((value) => value === page)) {
            const index = item.visible.indexOf(page);
            item.visible.splice(index, 1);
          } else {
            item.visible.push(page);
          }
        }
        return item;
      })
    );

    const bloqueToEdit = bloques.find((b) => b._id === module);
    bloqueToEdit.state = !bloqueToEdit.state;
    putBloqueInfo({ ...bloqueToEdit, updateSection });
  };

  const editBloqueInfo = (values) => {
    const bloquesEdit = bloques.map((b) => (b._id === values._id ? { ...values } : b));
    putBloqueInfo({ ...values, updated_date: new Date() }).then(({ data }) =>
      toast.success(data.message)
    );
    setBloques(bloquesEdit);
  };

  return (
    <HomeContext.Provider
      value={{
        sliders,
        banners,
        mensaje,
        handleVisibilitySlider,
        handlePublishButton,
        editSlider,
        deleteArticle,
        addSlider,
        addBanner,
        handleChecked,
        editBanner,
        deleteBanner,
        publicSliders,
        setFlag,
        flag,
        handleVisibilityBanners,
        addCategory,
        categories,
        setCategories,
        bloques,
        addBloqueInfo,
        deleteBloqueInfo,
        handleCheckedBloque,
        handleVisibilityBloque,
        editBloqueInfo,
        setBloques,
        setBanners,
        bloqueInfoEdit,
        setBloqueInfoEdit,
        setBannerEdit,
        bannerEdit
      }}
    >
      {children}
    </HomeContext.Provider>
  );
};

export { HomeProvider };

export default HomeContext;
